import { Trans } from '@lingui/react'

import InputCheckbox from 'views/components/molecules/InputCheckbox'

const CollectiveOrderCheckBox = ({
  onCheckBoxClick,
  isCollectiveOrderStatus,
  className,
}: {
  onCheckBoxClick: EventListener
  isCollectiveOrderStatus: boolean
  className?: string
}) => (
  <div className={className}>
    <div className="u-padding-small--top">
      <strong className="m-CollectiveOrderCheckbox__title">
        <Trans id="cart.notification.maxDosage.cartInfoBox.cta.title" />
      </strong>
    </div>
    <div className="l-flex u-padding-small--top">
      <InputCheckbox
        onClick={onCheckBoxClick}
        checked={isCollectiveOrderStatus}
        id="multiorder-cart-info-box"
        name="cart-infoBox-multiorder-input"
      >
        <p className="a-h4 u-no-margin u-margin-small--right">
          <Trans id="cart.notification.maxDosage.cartInfoBox.cta.label" />
        </p>
      </InputCheckbox>
    </div>
  </div>
)
export default CollectiveOrderCheckBox
